import { Box, Chip, IconButton, Tooltip, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/EditOutlined";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import UserActivity from "components/UserActivity";
import { Comment } from "models/Comment";
import { colors } from "@mui/material";
import { useAppSelector } from "app/hooks";
import { selectUserIsAdmin, selectUserIsUserAdmin } from "features/auth/authSlice";
import { useState } from "react";
import EditCommentDialog from "./EditCommentDialog";
import DeleteCommentDialog from "./DeleteCommentDialog";
import InitialsAvatar from "components/InitialsAvatar";

type ChecklistCommentProps = { comment: Comment };

const ChecklistComment: React.FC<ChecklistCommentProps> = (props) => {
  const { comment } = props;
  const isAdmin = useAppSelector(selectUserIsAdmin);
  const isUserAdmin = useAppSelector(selectUserIsUserAdmin);
  const [showEditDialog, setShowEditDialog] = useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);

  return (
    <Box
      key={comment.id}
      sx={{
        bgcolor: colors.grey[200],
        p: 2,
        borderRadius: 4,
        display: "grid",
        gridTemplateColumns: "auto 1fr auto",
        gap: 2,
        width: "fit-content",
      }}
    >
      <InitialsAvatar fullName={comment.poster.userName} />

      <Box>
        <UserActivity
          time={comment.postedAt}
          user={{ userId: comment.poster.id, userName: comment.poster.userName }}
        />
        {comment.type === "EXTERNAL_COMMENT" ? (
          <Tooltip title="Upplagd som extern kommentar i appen" arrow>
            <Chip label="Extern" size="small" color="secondary" />
          </Tooltip>
        ) : null}

        {comment.type === "ADDITIONAL_EQUIPMENT" && (
          <Tooltip title={'Upplagd som "tillägg" i appen'} arrow>
            <Chip label="Tillägg" size="small" color="success" />
          </Tooltip>
        )}

        <Typography
          component="pre"
          sx={{ mt: 1, whiteSpace: "break-spaces", overflowWrap: "anywhere" }}
        >
          {comment.message}
        </Typography>
      </Box>

      {(isAdmin || isUserAdmin) && (
        <Box sx={{ marginTop: -1 }}>
          <IconButton edge="end" onClick={() => setShowEditDialog(true)}>
            <EditIcon />
          </IconButton>
          <IconButton edge="end" onClick={() => setShowDeleteDialog(true)}>
            <DeleteIcon />
          </IconButton>
        </Box>
      )}

      {showEditDialog && (
        <EditCommentDialog onClose={() => setShowEditDialog(false)} comment={comment} />
      )}

      {showDeleteDialog && (
        <DeleteCommentDialog onClose={() => setShowDeleteDialog(false)} comment={comment} />
      )}
    </Box>
  );
};

export default ChecklistComment;
